import styled, { keyframes } from 'styled-components';

const SpinnerContainer = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column-reverse;
  background-color: #fff;
`;

const SpinnerText = styled.span`
  font-size: 16px;
  text-align: center;
  margin-top: 20px;
`;

const loading = keyframes`
  0% {
    top: 75px;
    left: 75px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0;
    left: 0;
    width: 150px;
    height: 150px;
    opacity: 0;
  }
`;

const Spinner = styled.div`
  position: relative;
  width: 150px;
  height: 150px;

  & div {
    position: absolute;
    border: 4px solid #03a9f4;
    opacity: 1;
    border-radius: 50%;
    animation: ${loading} 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;

    &:nth-child(2) {
      animation-delay: -0.5s;
    }
  }
`;

export {
  SpinnerContainer,
  SpinnerText,
  Spinner
}



// WEBPACK FOOTER //
// ./src/components/Loading/styles.js